<template>
  <div class="mb-4 pt-3" style="min-height: 90vh">
    <div class="container sm-px-0">
      <div class="row">
        <div class="col-lg-6 text-center text-lg-left">
          <h1 class="fw-600 h4">{{ $t("高价回收") }}</h1>
        </div>
        <div class="col-lg-6">
          <ul
              class="breadcrumb bg-transparent p-0 justify-content-center justify-content-lg-end"
          >
            <li class="breadcrumb-item opacity-50">
              <a class="text-reset" href="javascript:void(0)" @click="goto('/')">
                {{ $t("首页") }}
              </a>
            </li>
            <li class="text-dark fw-600 breadcrumb-item">
              <a class="text-reset" href="javascript:void(0)">
                {{ $t("高价回收") }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row">
        <img v-if="poster && poster.pic" class="rich-text" :src="getFileViewUrl(poster.pic)" style="width: 100%;"></img>
        <div v-if="poster" class="rich-text" v-html="getFileViewContent(poster.content)"></div>
        <van-form @submit="commit" style="margin: auto;padding: 20px 0;" label-width="140px" class="full-width">
          <van-field
              v-model="formObj.no"
              :label="$t('商品订单号')"
              :name="$t('商品订单号')"
              :placeholder="$t(`请输入`) + ' ' + $t('商品订单号')"
              :rules="[
                {
                  required: true,
                  message: $t(`请输入`) + ' ' + $t('商品订单号')
                },
              ]"
          />
          <van-field
              v-model="formObj.username"
              :label="$t('用户名')"
              :name="$t('用户名')"
              :placeholder="$t(`请输入`) + ' ' + $t('用户名')"
              :rules="[
                {
                  required: true,
                  message: $t(`请输入`) + ' ' + $t('用户名')
                },
              ]"
          />
          <van-field
              v-model="formObj.tkPassword"
              type="password"
              :label="$t('提款密码')"
              :name="$t('提款密码')"
              :placeholder="$t(`请输入`) + ' ' + $t('提款密码')"
              :rules="[
                {
                  required: true,
                  message: $t(`请输入`) + ' ' + $t('用户名')
                },
              ]"
          />
          <div style="margin: 16px;">
            <van-button
                round
                :loading="loading"
                :loading-text="$t('submitting')"
                block
                native-type="submit"
                small
                type="primary"
            >
              {{ $t("submit") }}
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
// 高价回收
export default {
  name: 'buyback',
  components: {},
  data() {
    return {
      loading: false,
      poster: null,
      formObj: {
        no: null,
        username: null,
      },
    }
  },
  async created() {
    this.poster = await this.getPoster("buyback") || {}
  },
  methods: {
    commit() {
      this.loading = true;
      let form = Object.assign({}, this.formObj);
      $$post("/user/goodsOrder/applyBuyback", form)
          .then(() => {
            this.loading = false;
            this.$toast.success(this.$t("Commit_Success"));
            // this.formObj.username = ''
            this.jump('/user/purchase_history')
          })
          .catch(() => {
            this.loading = false;
          });
    }
  }
}
</script>
